import { encrypt } from '@/common/securityUtils';
import { Form } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { useDynamicLocale } from '@/hoslog-intl';
import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAssignCharge } from './hooks/useAssignCharge';

export const AssignChargesForm = () => {
  const { form, chargeCategory, userTypeRefined, currentCharges } = useAssignCharge();

  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('assignCharge', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['charges'] });
      toast.success(res.message);
    },
  });
  const { t } = useDynamicLocale();
  const userType = [
    {
      value: encrypt('3'),
      label: t('configurationManagement.charges.table.customer'),
      labelEng: t('configurationManagement.charges.table.customer'),
      disabled: true,
    },
    {
      value: encrypt('4'),
      label: t('configurationManagement.charges.table.club'),
      labelEng: t('configurationManagement.charges.table.club'),
      disabled: true,
    },
    {
      value: encrypt('6'),
      label: t('configurationManagement.charges.table.affiliate'),
      labelEng: t('configurationManagement.charges.table.affiliate'),
    },
  ];
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        await mutateAsync({
          chargeCategoryId: data.newCommissionCategory,
          agentId: data.chargeType,
          agentType: data.userType,
        });
      }}
    >
      <div className="flex flex-col gap-4.5">
        <Select
          label="configurationManagement.charges.assignChargeModal.userType"
          {...form.register('userType')}
          options={userType}
          placeholder={t('configurationManagement.charges.assignChargeModal.selectUserType')}
        />
        <div>
          <Select
            label="configurationManagement.charges.assignChargeModal.user"
            {...form.register('chargeType')}
            placeholder={t('configurationManagement.charges.assignChargeModal.selectUser')}
            options={userTypeRefined}
          />
        </div>
        <Input
          label="configurationManagement.charges.assignChargeModal.currentCategoryCharge"
          {...form.register('currentCommissionCharge')}
          value={currentCharges.label}
          placeholder={t('configurationManagement.charges.assignChargeModal.currentCategoryCharge')}
          disabled
        />
        <Select
          label="configurationManagement.charges.assignChargeModal.newChargeCategory"
          {...form.register('newCommissionCategory')}
          options={chargeCategory}
          placeholder={t('configurationManagement.charges.assignChargeModal.selectChargeCategory')}
        />
      </div>
    </Form>
  );
};
